import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Sucursal } from 'app/models/sucursal.models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SucursalesService {

  constructor(private http: HttpClient) { }
  
  getAll(): Observable<Sucursal | any> {
    return this.http.get(environment.apiUrl + 'branches');
  }

  getById(id): Observable<Sucursal | any> {
    return this.http.get(environment.apiUrl + 'branches/' + id);
  }

  guardar(ptoventa: Sucursal): Observable<any> {
    return this.http.post(environment.apiUrl + 'branches', ptoventa);
  }

  actualizar(ptoventa: Sucursal): Observable<any> {
    return this.http.patch(`${environment.apiUrl}branches/${ptoventa.id}`, ptoventa);
  }

  eliminar(ptoventa: Sucursal): Observable<any> {
    return this.http.delete(`${environment.apiUrl}branches/${ptoventa.id}`);
  }
    
}
